import { Button } from "@mui/material";
import PropTypes from "prop-types";
import styles from "./Structure.module.css";
import { useNavigate } from 'react-router-dom';

const Structure = ({ className = "" }) => {

  const navigate = useNavigate();
  
  const handleButtonClick = () => {
    navigate('../createaccount');
  };

  return (
    <section className={[styles.structure, className].join(" ")}>
      <div className={styles.structureChild} />
      <div className={styles.fantasyHqWrapper}>
        <h1 className={styles.fantasyHq}>Fantasy League Central</h1>
      </div>
      <h3 className={styles.simplifyYourJob}>
        Simplify your job as a fantasy league commissioner. Manage all your
        responsibilities in one place, get rid of all your spreadsheets, and keep your league members easily
        informed on league rules and activity with minimal effort.
      </h3>
      <div className={styles.structureInner}>
        <Button
          className={styles.frameChild}
          disableElevation
          variant="contained"
          sx={{
            textTransform: "none",
            color: "#fff",
            fontSize: "16",
            background: "#013369",
            borderRadius: "10px",
            "&:hover": { background: "#013369" },
            width: 156,
            height: 48,
          }}
          onClick={handleButtonClick}
        >
          Get Started
        </Button>
      </div>
    </section>
  );
};

Structure.propTypes = {
  className: PropTypes.string,
};

export default Structure;